var map = {
	"./add.svg": "c2a3",
	"./address-company.svg": "3321",
	"./address-home.svg": "b4bb",
	"./address-school.svg": "75c7",
	"./advertisement-pool.svg": "d1e4",
	"./aircraft.svg": "27fb",
	"./alipay-icon.svg": "af4a",
	"./all-orders.svg": "748b",
	"./anchor-point.svg": "dc74",
	"./arrow-down.svg": "1033",
	"./arrow.svg": "b6e4",
	"./be-delivered.svg": "805a",
	"./bell-icon-blak.svg": "36ec",
	"./bell-icon.svg": "ed3d",
	"./businessmen-stationed.svg": "d462",
	"./calendar-wallet-order.svg": "e8f0",
	"./chain-cat-boutique.svg": "0f06",
	"./chain-cat-member.svg": "7bde",
	"./close-popup.svg": "42a9",
	"./cm-area.svg": "f19b",
	"./coin-pay.svg": "5ab3",
	"./collar-cm.svg": "7ef2",
	"./consumption-pool.svg": "43f4",
	"./copy-link.svg": "4f49",
	"./correct.svg": "5b4a",
	"./coupon-svg.svg": "8b0b",
	"./courier.svg": "7e7e",
	"./customer-service.svg": "853d",
	"./dialog-close.svg": "06fa",
	"./feedback-svg.svg": "4099",
	"./gray-btn.svg": "f971",
	"./green-btn.svg": "432c",
	"./heart-full.svg": "749a",
	"./heart-null-black.svg": "1fc2",
	"./heart-null.svg": "9b6d",
	"./help-center.svg": "b9c9",
	"./hot.svg": "443a",
	"./icon-alertwarn.svg": "13cf",
	"./icon-delete.svg": "c046",
	"./left-btn.svg": "1769",
	"./logistics-logo.svg": "cf43",
	"./message-center.svg": "86c6",
	"./message-round.svg": "aebc",
	"./mini-right-btn.svg": "b78c",
	"./my-assets.svg": "ce2c",
	"./my-complaint.svg": "9541",
	"./my-reminder.svg": "610c",
	"./node-application.svg": "3f07",
	"./node-pool.svg": "0d27",
	"./notice-wallet.svg": "79ba",
	"./order-info.svg": "8a20",
	"./pay-success.svg": "e384",
	"./pending-pay.svg": "ba30",
	"./pending-receipt.svg": "1723",
	"./point.svg": "61c5",
	"./pool-count.svg": "e694",
	"./processbar.svg": "de0c",
	"./product-help.svg": "699f",
	"./qq-icon.svg": "747c",
	"./qq-space.svg": "ecb5",
	"./question-mark.svg": "1e8d",
	"./red-flag.svg": "53fd",
	"./right-arrow.svg": "8e1e",
	"./search.svg": "8e8d",
	"./setting.svg": "05ff",
	"./share-btn-black.svg": "5460",
	"./share-btn.svg": "f43a",
	"./sharing-links.svg": "f68a",
	"./shipped.svg": "43fc",
	"./shipping-address.svg": "f8b3",
	"./shopping-cart.svg": "43cc",
	"./sigh.svg": "a698",
	"./therr-point.svg": "d086",
	"./transparent-btn.svg": "0488",
	"./wallet-balance-icon.svg": "68c5",
	"./wallet-balance.svg": "b290",
	"./wallet-consumption-icon.svg": "1bd7",
	"./wallet-consumption.svg": "63a1",
	"./wallet-four-big.svg": "1258",
	"./wallet-four.svg": "985f",
	"./wallet-one-big.svg": "b606",
	"./wallet-one.svg": "7c53",
	"./wallet-order-message.svg": "3db2",
	"./wallet-right-arrow.svg": "c7fe",
	"./wallet-right-gray-arrow.svg": "cd19",
	"./wallet-three-big.svg": "d555",
	"./wallet-three.svg": "04d7",
	"./wallet-two-big.svg": "0394",
	"./wallet-two.svg": "3748",
	"./we-blog.svg": "f59e",
	"./we-char.svg": "b8c8",
	"./we-chat-friends.svg": "8daf",
	"./white-btn.svg": "336c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";